import { render } from "./site.vue?vue&type=template&id=4c451cf9&scoped=true"
import script from "./site.vue?vue&type=script&lang=js"
export * from "./site.vue?vue&type=script&lang=js"

import "./site.vue?vue&type=style&index=0&id=4c451cf9&scoped=true&lang=less"

import exportComponent from "D:\\perject\\suyuan\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c451cf9"]])

export default __exports__